module.exports = __webpack_public_path__ + "static/fonts/iconfont.6ccfd848.ttf";